
import { defineComponent, PropType, ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import charModule from '@store/modules/char';
import { getPlayData, IPlayDataParams, PlayDataTypeEnum } from '@api/api';
import BattleList from './BattleList.vue';
import Loading from '../common/Loading.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'BattleSquad',
  props: {
    dataType: {
      type: Array as PropType<string[]>,
      require: true,
    },
    cardIds: {
      type: String,
      require: true,
    },
    startTime: {
      type: String,
      require: true,
    },
    endTime: {
      type: String,
      require: true,
    },
    pageSize: {
      type: Number,
      require: true,
    },
    isDetail: {
      type: Number,
      require: true
    },
    fromRole: {
      type: Boolean,
      default: false
    }
  },
  setup(props: any) {
    const { t } = useI18n();
    const store = useStore();
    !store.hasModule('char') && store.registerModule('char', charModule);
    const battleArray = reactive([]);
    const boolFinishGetData = ref(false);
    const noBattleData = computed(() => {
      if(battleArray.length <= 0) return true;
      return battleArray.every((item) => {
        return !item.hasData;
      })
    })

    const gatPlayData = async () => {
      const requestArr = [];
      const dataType = props.dataType;
      for (let i = 0, length = dataType.length; i < length; i++) {
        const params: IPlayDataParams = {
          gameId: store.state.gameId,
          dataType: PlayDataTypeEnum[dataType[i]],
          cardIds: props.cardIds,
          startTime: props.startTime,
          endTime: props.endTime,
          pageSize: props.pageSize,
          isDetail: props.isDetail
        };
        requestArr.push(getPlayData(params));
      }
      return Promise.all(requestArr);
    };

    const formatPlayData = async () => {
      const playDataArr = await gatPlayData();
      const dataType = props.dataType;
      for (let i = 0, length = playDataArr.length; i < length; i++) {
        try {
          if (
            playDataArr[i].result == 1 &&
            playDataArr[i].data.teamInfo &&
            JSON.stringify(playDataArr[i].data.teamInfo) !== '{}' &&
            !/Array/i.test(playDataArr[i].data.teamInfo.constructor.toString())
          ) {
            battleArray.push({
              key: t(dataType[i]),
              value: playDataArr[i].data.teamInfo,
              hasData: true
            });
          } else {
            battleArray.push({
              key: t(dataType[i]),
              value: { },
              hasData: false
            });
          }
        } catch (e) {
          console.error(e);
        }
      }
      boolFinishGetData.value = true;
      window.dataLayer.push(({
        event: 'view_page',
        pageName: playDataArr.length > 0 ? '阵容排行_阵容排行' : '阵容排行_无匹配阵容'
      }))
    };

    formatPlayData();

    return {
      boolFinishGetData,
      battleArray,
      noBattleData,
    };
  },
  components: { BattleList, Loading },
});
